/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Restrict_To_BranchesInputs */

const en_users_form_restrict_to_branches = /** @type {(inputs: Users_Form_Restrict_To_BranchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restrict to specific branches (optional)…`)
};

const pt_br2_users_form_restrict_to_branches = /** @type {(inputs: Users_Form_Restrict_To_BranchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restringir a filiais específicas (opcional)…`)
};

/**
* | output |
* | --- |
* | "Restrict to specific branches (optional)…" |
*
* @param {Users_Form_Restrict_To_BranchesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_restrict_to_branches = /** @type {((inputs?: Users_Form_Restrict_To_BranchesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Restrict_To_BranchesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_restrict_to_branches(inputs)
	return pt_br2_users_form_restrict_to_branches(inputs)
});